import {patchFormData} from "@/lib/fetcher.js";

export async function patchCandidateCompliance(candidate_id, id, data) {
    return await patchFormData(`/admin/candidates/${candidate_id}/candidate_compliances`,id, data );
}
